import React, { useEffect, useState } from "react";
import { api } from "./adminApi";

export default function AdminSettings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");

  const [form, setForm] = useState({
    site_name_en: "",
    site_name_kn: "",
    top_banner_en: "",
    top_banner_kn: "",
    footer_about_en: "",
    footer_about_kn: "",
    contact_phone: "",
    contact_email: "",
    contact_address_en: "",
    contact_address_kn: "",
    facebook_url: "",
    twitter_url: "",
    youtube_url: "",
    instagram_url: "",
    is_active: 1,
  });

  const load = async () => {
    setErr("");
    setOk("");
    setLoading(true);
    try {
      const res = await api.get("/api/admin/settings");
      const s = res.data || {};
      setForm((p) => ({ ...p, ...s }));
    } catch (e) {
      setErr(e?.response?.data?.message || e?.message || "Failed to load settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onChange = (k, v) => {
    setOk("");
    setForm((p) => ({ ...p, [k]: v }));
  };

  const onSave = async (e) => {
    e.preventDefault();
    setErr("");
    setOk("");
    setSaving(true);
    try {
      await api.put("/api/admin/settings", form);
      setOk("Saved successfully.");
      await load();
    } catch (e2) {
      setErr(e2?.response?.data?.message || e2?.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <div style={styles.title}>Site Settings</div>
          <div style={styles.sub}>
            Update About Us, Contact Us and the top banner shown on the landing page.
          </div>
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={load} style={styles.ghostBtn} disabled={loading || saving}>
            Refresh
          </button>
          <button form="settingsForm" type="submit" style={styles.saveBtn} disabled={loading || saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>

      {err ? <div style={styles.alertErr}>{err}</div> : null}
      {ok ? <div style={styles.alertOk}>{ok}</div> : null}

      <form id="settingsForm" onSubmit={onSave} style={styles.card}>
        {loading ? (
          <div style={styles.loading}>Loading…</div>
        ) : (
          <div style={styles.grid}>
            <Field label="Site Name (English)">
              <input
                value={form.site_name_en || ""}
                onChange={(e) => onChange("site_name_en", e.target.value)}
                style={styles.input}
                placeholder="Community Portal"
              />
            </Field>

            <Field label="Site Name (Kannada)">
              <input
                value={form.site_name_kn || ""}
                onChange={(e) => onChange("site_name_kn", e.target.value)}
                style={styles.input}
                placeholder="ಕನ್ನಡ ಸೈಟ್ ಹೆಸರು"
              />
            </Field>

            <Field label="Top Banner (English)">
              <textarea
                value={form.top_banner_en || ""}
                onChange={(e) => onChange("top_banner_en", e.target.value)}
                style={styles.textarea}
                rows={3}
                placeholder="This appears at the top of the landing page."
              />
            </Field>

            <Field label="Top Banner (Kannada)">
              <textarea
                value={form.top_banner_kn || ""}
                onChange={(e) => onChange("top_banner_kn", e.target.value)}
                style={styles.textarea}
                rows={3}
                placeholder="ಲ್ಯಾಂಡಿಂಗ್ ಪೇಜ್ ಮೇಲಿನ ಬ್ಯಾನರ್"
              />
            </Field>

            <div style={styles.fullRow}>
              <div style={styles.sectionTitle}>About Us</div>
            </div>

            <Field label="About Us (English)">
              <textarea
                value={form.footer_about_en || ""}
                onChange={(e) => onChange("footer_about_en", e.target.value)}
                style={styles.textarea}
                rows={6}
                placeholder="Write About Us content in English"
              />
            </Field>

            <Field label="About Us (Kannada)">
              <textarea
                value={form.footer_about_kn || ""}
                onChange={(e) => onChange("footer_about_kn", e.target.value)}
                style={styles.textarea}
                rows={6}
                placeholder="ಕನ್ನಡದಲ್ಲಿ ನಮ್ಮ ಬಗ್ಗೆ"
              />
            </Field>

            <div style={styles.fullRow}>
              <div style={styles.sectionTitle}>Contact Us</div>
            </div>

            <Field label="Phone">
              <input
                value={form.contact_phone || ""}
                onChange={(e) => onChange("contact_phone", e.target.value)}
                style={styles.input}
                placeholder="+91 ..."
              />
            </Field>

            <Field label="Email">
              <input
                value={form.contact_email || ""}
                onChange={(e) => onChange("contact_email", e.target.value)}
                style={styles.input}
                placeholder="support@example.com"
              />
            </Field>

            <Field label="Address (English)">
              <textarea
                value={form.contact_address_en || ""}
                onChange={(e) => onChange("contact_address_en", e.target.value)}
                style={styles.textarea}
                rows={4}
                placeholder="Full address in English"
              />
            </Field>

            <Field label="Address (Kannada)">
              <textarea
                value={form.contact_address_kn || ""}
                onChange={(e) => onChange("contact_address_kn", e.target.value)}
                style={styles.textarea}
                rows={4}
                placeholder="ಕನ್ನಡ ವಿಳಾಸ"
              />
            </Field>

            <div style={styles.fullRow}>
              <div style={styles.sectionTitle}>Social Links</div>
            </div>

            <Field label="YouTube">
              <input
                value={form.youtube_url || ""}
                onChange={(e) => onChange("youtube_url", e.target.value)}
                style={styles.input}
                placeholder="https://youtube.com/..."
              />
            </Field>

            <Field label="Instagram">
              <input
                value={form.instagram_url || ""}
                onChange={(e) => onChange("instagram_url", e.target.value)}
                style={styles.input}
                placeholder="https://instagram.com/..."
              />
            </Field>

            <Field label="Facebook">
              <input
                value={form.facebook_url || ""}
                onChange={(e) => onChange("facebook_url", e.target.value)}
                style={styles.input}
                placeholder="https://facebook.com/..."
              />
            </Field>

            <Field label="Twitter/X">
              <input
                value={form.twitter_url || ""}
                onChange={(e) => onChange("twitter_url", e.target.value)}
                style={styles.input}
                placeholder="https://x.com/..."
              />
            </Field>

            <div style={styles.fullRow}>
              <label style={styles.toggleRow}>
                <input
                  type="checkbox"
                  checked={String(form.is_active) === "1" || form.is_active === 1}
                  onChange={(e) => onChange("is_active", e.target.checked ? 1 : 0)}
                />
                <span style={{ fontWeight: 600 }}>Active</span>
              </label>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ display: "grid", gap: 6 }}>
      <div style={styles.label}>{label}</div>
      {children}
    </div>
  );
}

const styles = {
  page: {
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial",
    padding: 18,
    maxWidth: 1100,
    margin: "0 auto",
    color: "#0f172a",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 12,
  },
  title: { fontSize: 24, fontWeight: 700, letterSpacing: "-0.3px" },
  sub: { marginTop: 6, color: "#475569", fontSize: 13.5, fontWeight: 500 },
  ghostBtn: {
    border: "1px solid #e2e8f0",
    background: "#fff",
    borderRadius: 12,
    padding: "10px 12px",
    fontWeight: 600,
    cursor: "pointer",
  },
  saveBtn: {
    border: 0,
    borderRadius: 12,
    padding: "10px 14px",
    fontWeight: 700,
    cursor: "pointer",
    color: "#fff",
    background: "linear-gradient(135deg,#0ea5e9,#6366f1)",
  },
  card: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 18,
    boxShadow: "0 10px 26px rgba(2,6,23,.06)",
    overflow: "hidden",
  },
  grid: {
    padding: 16,
    display: "grid",
    gap: 12,
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  },
  fullRow: { gridColumn: "1 / -1" },
  sectionTitle: { fontSize: 13.5, fontWeight: 700, color: "#0f172a", marginTop: 6 },
  label: { fontSize: 12.5, fontWeight: 600, color: "#0f172a" },
  input: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    padding: "10px 12px",
    fontSize: 14,
    outline: "none",
    fontWeight: 500,
  },
  textarea: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    padding: "10px 12px",
    fontSize: 14,
    outline: "none",
    resize: "vertical",
    fontWeight: 500,
  },
  toggleRow: { display: "flex", gap: 10, alignItems: "center", paddingTop: 6 },
  alertErr: {
    marginBottom: 12,
    borderRadius: 14,
    padding: 12,
    background: "#fef2f2",
    border: "1px solid #fecaca",
    color: "#991b1b",
    fontWeight: 600,
  },
  alertOk: {
    marginBottom: 12,
    borderRadius: 14,
    padding: 12,
    background: "#ecfeff",
    border: "1px solid #a5f3fc",
    color: "#155e75",
    fontWeight: 700,
  },
  loading: { padding: 16, fontWeight: 600, color: "#475569" },
};
